// Option types
export const FETCH_OPTIONS_START = "FETCH_OPTIONS_START"
export const FETCH_OPTIONS_SUCCESS = "FETCH_OPTIONS_SUCCESS"
export const FETCH_OPTIONS_ERROR = "FETCH_OPTIONS_ERROR"

// Single option types
export const CREATE_OPTION_START = "OPTION_CREATE_START"
export const CREATE_OPTION_SUCCESS = "OPTION_CREATE_SUCCESS"
export const CREATE_OPTION_ERROR = "OPTION_CREATE_ERROR"
export const DELETE_OPTION_START = "DELETE_OPTION_START"
export const DELETE_OPTION_SUCCESS = "DELETE_OPTION_SUCCESS"
export const DELETE_OPTION_ERROR = "DELETE_OPTION_ERROR"
export const UPDATE_OPTION_START = "UPDATE_OPTION_START"
export const UPDATE_OPTION_SUCCESS = "UPDATE_OPTION_SUCCESS"
export const UPDATE_OPTION_ERROR = "UPDATE_OPTION_ERROR"

// Sum calculation types
export const SET_SELECTED_OPTIONS = "SET_SELECTED_OPTIONS"
export const CLEAN_SELECTED_OPTIONS = "CLEAN_SELECTED_OPTIONS"
export const SEND_CALCULATION_START = "SEND_CALCULATION_START"
export const SEND_CALCULATION_SUCCESS = "SEND_CALCULATION_SUCCESS"
export const SEND_CALCULATION_ERROR = "SEND_CALCULATION_ERROR"

export const RESET_MAIL_SENT = "RESET_MAIL_SENT"
